
import { Vue } from 'vue-property-decorator';
import Logo from '@shared/components/Logo.vue';
import Breadcrumb from '@shared/components/Breadcrumb.vue';
import SearchBox from '@shared/components/SearchBox.vue';

Vue.component('Logo', Logo);
Vue.component('Breadcrumb', Breadcrumb);
Vue.component('SearchBox', SearchBox);
